/**
 * Context for pages to set a custom header title (e.g. "Edit Admin / John Doe").
 * AuthLayoutV2 reads from this; falls back to getPageTitle(pathname) when null.
 */
import React, { createContext, useContext, useState, useCallback } from "react";

const PageTitleContext = createContext(null);

export function PageTitleProvider({ children }) {
  const [customTitle, setCustomTitle] = useState(null);
  const setPageTitle = useCallback((title) => setCustomTitle(title), []);
  return (
    <PageTitleContext.Provider value={{ customTitle, setPageTitle }}>
      {children}
    </PageTitleContext.Provider>
  );
}

export function usePageTitle() {
  const ctx = useContext(PageTitleContext);
  return ctx?.setPageTitle ?? (() => {});
}

export function useCustomPageTitle() {
  const ctx = useContext(PageTitleContext);
  return ctx?.customTitle ?? null;
}
